import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ContentCell } from ".";
import { AmtAlert } from "../../../../../components";
import { OrganizationMembership } from "../../../../../modules/authentication/domain";
import { HeaderCell } from "../../../../components/Tables";
import { useDeleteAdminForm } from "../../state";

interface AdminTableProps {
  adminUsers: OrganizationMembership[];
}

export const AdminTable: React.FC<AdminTableProps> = ({ adminUsers }) => {
  const { t } = useTranslation("admin-management");
  const form = useDeleteAdminForm();

  return (
    <Box
      sx={{
        marginTop: "36px",
        border: "1px solid",
        borderColor: "shades.greyExtraLight",
        borderRadius: "6px",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          maxHeight: "100vh",
          overflow: "auto",
          "&:focus": {
            boxShadow: "0 0 0.5em rgba(0, 0, 0, 0.5)",
            outline: 0,
          },
        }}
      >
        <Table
          sx={{
            whiteSpace: "nowrap",
            margin: "0",
            borderCollapse: "separate",
            borderSpacing: "0",
            width: "100%",
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                "&:hover": {
                  color: "red",
                },
              }}
            >
              <HeaderCell label={t("table.header.name")} />
              <HeaderCell label={t("table.header.email")} />
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              textAlign: "center",
              position: "relative",
            }}
          >
            {adminUsers && adminUsers.length > 0 ? (
              adminUsers.map((admin) => {
                return (
                  <TableRow
                    key={admin.id}
                    sx={{
                      borderBottom: "1px solid",
                      borderColor: "shades.greyExtraLight",
                      backgroundColor: "white",
                      "&:nth-of-type(even)": {
                        backgroundColor: "#FBFBFB",
                      },
                      "&:last-child": {
                        border: "none",
                        " > td": {
                          borderBottom: "none",
                        },
                      },
                      "&:hover": {
                        backgroundColor: "green.light",
                      },
                    }}
                  >
                    <ContentCell content={admin.user.name.full} />
                    <ContentCell
                      content={admin.user.email.value}
                      deleteItem={() => form.openDialog(admin)}
                    />
                  </TableRow>
                );
              })
            ) : (
              <TableRow
                sx={{
                  padding: "4px 8px",
                  border: "none",
                  " > td": {
                    borderBottom: "none",
                  },
                }}
              >
                <TableCell colSpan={3}>
                  <AmtAlert
                    title={t("table.alert-title")}
                    text={t("table.not-available")}
                    variant="neutral"
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};
